import React from 'react'
import * as classes from './togglemenu.module.scss'
import { Link } from "gatsby"
import Hover from '../hover/hover'

export default function ToggleMenu(props) {
    return (
        <React.Fragment>
            <nav className={classes.ToggleMenu + " " + (props.show ? classes.ToggleMenuShown : null)}>
                <i aria-hidden="true" onKeyDown={props.toggle} onClick={props.toggle} className={"icon-cancel " + classes.CloseButton}></i>
                <ul>
                    <li><Link to={"/"}>Home</Link></li>
                    {/* <li><Link to={"/archive"}>Archive</Link></li> */}
                </ul>
            </nav>
            <Hover show={props.show} onKeyDown={props.toggle} click={props.toggle} />
        </React.Fragment>
    )
}